/*
包含n个接口请求函数的模块
函数的返回值: promise对象
 */
import  ajax from './request'
const BASE_URL = "https://platform-api.flyouxi.cn/"

// 获取接口数据
export const reqData = (service,data,type = 'POST') => ajax(BASE_URL+service,data,type);
export const reqData1 = (service,data,type = 'POST') => ajax(service,data,type);



// WEBPACK FOOTER //
// ./src/api/index.js